export type OrgNameAvailability = 'available' | 'taken' | 'error';

// Calls the public vector-api endpoint that proxies PropelAuth's fetchOrgByQuery.
// Returns 'error' on network failure or abort so callers can degrade gracefully.
export async function checkOrgNameAvailability(
  apiBaseUrl: string,
  name: string,
  signal?: globalThis.AbortSignal
): Promise<OrgNameAvailability> {
  const trimmed = name.trim();
  if (!trimmed) return 'error';
  try {
    const params = new URLSearchParams({name: trimmed});
    const response = await fetch(`${apiBaseUrl}/orgs/check-name?${params.toString()}`, {signal});
    if (!response.ok) return 'error';
    const result = (await response.json()) as {exists: boolean};
    return result.exists ? 'taken' : 'available';
  } catch (err: unknown) {
    if ((err as {name?: string})?.name === 'AbortError') return 'error';
    return 'error';
  }
}
